import React from 'react';

import { Box } from '@mui/joy';
import CircularProgress from '@mui/material/CircularProgress';

interface LoadingOverlayProps {
  isPending: boolean;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ isPending }) => {
  if (!isPending) return null;

  return (
    <Box
      className='absolute inset-0 flex items-center justify-center backdrop-blur-sm z-50'
      sx={{
        bgcolor: 'background.level1',
        opacity: 0.5,
        zIndex: 9999999999
      }}
    >
      <CircularProgress color='inherit' size='3rem' />
    </Box>
  );
};

export default LoadingOverlay;
